// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"section_sidebar__3YX16","log":"section_log__2yx8z"};